import axios, { AxiosError } from 'axios';
import {
    beginMutationLoading,
    endMutationLoading,
    shouldTrackMutationRequest,
} from './mutationLoader';

export  function  setupAPIclient(token?: string) {
    
    const api = 
    axios.create({
        baseURL: 'https://alexios.com.br:9598', // Altere para o domínio
        timeout: 8000,
        headers: { 
            'Authorization': 'Bearer ' + token
        },

    }) 
    api.interceptors.request.use(
        (config) => {
            const shouldTrack = shouldTrackMutationRequest(config.method, config.url);
            (config as any).__trackMutationLoader = shouldTrack;
            if (shouldTrack) beginMutationLoading();
            return config;
        },
        (error) => Promise.reject(error)
    );

    api.interceptors.response.use(
        (response) => {
            if ((response.config as any)?.__trackMutationLoader) {
                endMutationLoading();
            }
            return response;
        },
        (error: AxiosError) => {
            if ((error.config as any)?.__trackMutationLoader) {
                endMutationLoading();
            }
            console.error("Erro na requisição:", error.message);
            return 401; // Rejeita corretamente
        }
    );
    return api
}


